import { useMemo } from 'react';
import styled from 'styled-components';
import withErrorBoundary from '../ErrorBoundary';
import { UI_USAGE_LIMIT_COUNTER } from '../_core/common/constants/ErrorBoundaryNames';
import InAppCountDisplay from './counter/InAppCountDisplay';
import UsageLimitToolTip from './counter/UsageLimitToolTip';
import { validateDate } from './counter/validateDate';
import { validateNumber } from './counter/validateNumber';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "UIUsageLimitCounter__StyledDiv"
})(({
  theme
}) => ({
  cursor: 'default',
  display: 'inline-flex',
  lineHeight: '1.5',
  padding: theme.space['200'],
  borderRadius: theme.borderRadius['200'],
  backgroundColor: theme.color['fill-surface-default'],
  '&:hover': {
    backgroundColor: theme.color['fill-surface-raised']
  }
}));
const UIUsageLimitCounter = ({
  upgradeKey,
  currentUsage,
  usageLimit,
  limitResetDate,
  dataTestId,
  usageLimitNextTier
}) => {
  const validatedCurrentUsage = useMemo(() => validateNumber(currentUsage, upgradeKey, 'currentUsage'), [currentUsage, upgradeKey]);
  const validatedUsageLimit = useMemo(() => validateNumber(usageLimit, upgradeKey, 'usageLimit'), [usageLimit, upgradeKey]);
  const validatedLimitResetDate = useMemo(() => limitResetDate ? validateDate(limitResetDate, upgradeKey) : limitResetDate, [limitResetDate, upgradeKey]);
  const usageRemaining = Math.max(0, usageLimit - currentUsage);
  if (validatedUsageLimit === null || validatedUsageLimit === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UsageLimitToolTip, {
    currentUsage: validatedCurrentUsage,
    limitResetDate: validatedLimitResetDate,
    upgradeKey: upgradeKey,
    usageLimit: validatedUsageLimit,
    usageLimitNextTier: usageLimitNextTier,
    children: /*#__PURE__*/_jsx(StyledDiv, {
      children: /*#__PURE__*/_jsx(InAppCountDisplay, {
        upgradeKey: upgradeKey,
        currentUsage: validatedCurrentUsage,
        usageLimit: validatedUsageLimit,
        dataTestId: dataTestId,
        usageRemaining: usageRemaining
      })
    })
  });
};
export default withErrorBoundary(UIUsageLimitCounter, {
  boundaryName: UI_USAGE_LIMIT_COUNTER
});